import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { GetFormatedDateWithTime } from '../../../../common/Utils'
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';
import PrimaryTab from "./tabs/PrimaryTab";
import StatusTab from "./tabs/StatusTab";
import UOMTab from "./tabs/UOMTab";
import UserDefinedTab from "./tabs/UserDefinedTab";
import SerialNumberTab from "../../common/SerialNumberTab";
import LocationsTab from "../../common/LocationsTab";
import UnavailableTab from "../../common/UnavailableTab";
import SublotsTab from "./tabs/SublotsTab";
import ChargesTab from "../../common/ChargesTab";

var skipDataLoading = false;
var reOrderMethodFlag = false;


function Form(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        KEYSEQUENCE: 1,
        CREATIONDATETIME: null,
        CREATIONUSERID: '',
        LASTUPDATEDATETIME: null,
        LASTUPDATEUSERID: '',
        COMPANYID: '',
        MODULE: 'WM',
        RECORDTYPE: 'R',
        R_ITEM: '',
        PROFILECODE: '',
        CUSTOMERCODE: '',
        LOTCODE: '',
        DESCRIPTION_1: '',
        DESCRIPTION_2: '',
        STATUS: 'A',
        COMMENT: '',
        R_VENDOR: '',
        ROUTECODE: '',
        R_LOCATION: '',
        LOTSIZECODE: '',
        LOTPROJECTIONCODE: '',
        LOTUNITUOMFLAG: '',
        LOTUOMDEFAULT: '',
        LOTUNITSPERITEMUNIT: null,
        ROYALTYFLAG: '',
        ROYALTYUNITCOST: null,
        ROYALTYUNITPRICE: null,
        ROYALTYADDTOPRICEFLAG: '',
        STAGEFLAG: '',
        REORDERINVENTORYMINIMUMQTY: null,
        REORDERINVENTORYMAXIMUMQTY: null,
        REORDERQUANTITYEOQCALCULATED: null,
        REORDERQUANTITYORDERMULTIPLE: null,
        REORDERSAFETYQUANTITY: null,
        REORDERLEADTIME: null,
        COSTBASISMETHODFLAG: '',
        AVERAGECOST: null,
        STANDARDCOST: null,
        R_PRICETABLE: '',
        COREPRICE: null,
        MAXIMUMPRICELEVELFORDISCOUNT: '',
        TRADEDISCOUNTONSPECIALPRICE_AR: '',
        EARLYPAYDISCOUNTFLAG: '',
        COSTALLOCATIONFACTOR: null,
        DATEINTRODUCED: new Date(),
        REORDERQUANTITYENTERED: null,
        DATEAVAILABLE: new Date(),
        REORDERMETHODFLAG: 'N',
        DATEEXPIRATION: null,
        REORDERMINIMUMDAYSONHAND: null,
        REORDERMAXIMUMDAYSONHAND: null,
        CLASSCODE: '',
        SUBCLASSCODE: '',
        R_PRODUCTCATEGORY: '',
        R_OEMMANUFACTUREID: '',
        OEMMANUFACTURERCODE: '',
        VENDORITEMCODE: '',
        PHYSICALCOUNTCODE: '',
        USERDEFINEDCODE_1: '',
        USERDEFINEDCODE_2: '',
        USERDEFINEDCODE_3: '',
        USERDEFINEDCODE_4: '',
        USERDEFINEDCODE_5: '',
        USERDEFINEDCODE_6: '',
        USERDEFINEDCODE_7: '',
        USERDEFINEDCODE_8: '',
        USERDEFINEDCODE_9: '',
        USERDEFINEDCODE_10: '',
        USERDEFINEDREFERENCE_1: '',
        USERDEFINEDREFERENCE_2: '',
        USERDEFINEDREFERENCE_3: '',
        USERDEFINEDREFERENCE_4: '',
        USERDEFINEDREFERENCE_5: '',
        USERDEFINEDREFERENCE_6: '',
        USERDEFINEDREFERENCE_7: '',
        USERDEFINEDREFERENCE_8: '',
        USERDEFINEDREFERENCE_9: '',
        USERDEFINEDREFERENCE_10: '',
        USERDEFINEDDATE_1: null,
        USERDEFINEDDATE_2: null,
        USERDEFINEDDATE_3: null,
        USERDEFINEDDATE_4: null,
        USERDEFINEDDATE_5: null,
        USERDEFINEDDATE_6: null,
        USERDEFINEDDATE_7: null,
        USERDEFINEDDATE_8: null,
        USERDEFINEDDATE_9: null,
        USERDEFINEDDATE_10: null,
        USERDEFINEDQUANTITY_1: null,
        USERDEFINEDQUANTITY_2: null,
        USERDEFINEDQUANTITY_3: null,
        USERDEFINEDQUANTITY_4: null,
        USERDEFINEDQUANTITY_5: null,
        USERDEFINEDQUANTITY_6: null,
        USERDEFINEDQUANTITY_7: null,
        USERDEFINEDQUANTITY_8: null,
        USERDEFINEDQUANTITY_9: null,
        USERDEFINEDQUANTITY_10: null,
        INVENTORYUNITUOM: '',
        PIECESPERUNITUOM: '',
        PIECESPERUNITQUANTITY: null,
        UNITSPERPACKAGEUOM: '',
        UNITSPERPACKAGEQUANTITY: null,
        PACKAGESPERSHIPPINGUNITUOM: '',
        PACKAGESPERSHIPPINGUNITQTY: null,
        UNITVOLUMEUOM: '',
        UNITVOLUMEQUANTITY: null,
        UNITAREAUOM: '',
        UNITAREAQUANTITY: null,
        UNITVALUEUOM: '',
        NETWEIGHTUOM: '',
        NETWEIGHTQUANTITY: null,
        GROSSWEIGHTUOM: '',
        UNITVALUEQUANTITY: null,
        GROSSWEIGHTQUANTITY: null,
        ON_HAND: 0,
        IN_ORDERED: 0,
        OUT_ORDERED: 0,
        IN_RECEIVING: 0,
        OUT_SHIPPED: 0,
        IN_BACKORDER: 0,
        OUT_BACKORDER: 0,
        IN_UNAVAILABLE: 0,
        OUT_UNAVAILABLE: 0,
        IN_FUTURE: 0,
        OUT_FUTURE: 0,
        AVAILABLE: 0,
        NETAVAILABLE: 0,
        STORAGEBILLINGSTARTDATE: new Date(),
        STORAGEBILLINGENDDATE: new Date(2999, 11, 31),
        R_RATESCHEDULE: '',
        POPUPMESSAGE: '',
        LASTCOST: null,
        SIZE_1: null,
        R_BUYER: '',
        SIZE_2: null,
        STORAGEBILLEDDATE_LAST: null,
        STORAGEBILLEDDATE_NEXT: null,
        PRICESOURCE: '',
        PRICEMETHOD: '',
        CALCMETHOD: '',
        PRICELEVELA: null,
        PRICELEVELB: null,
        PRICELEVELC: null,
        PRICELEVELD: null,
        PRICELEVELE: null,
        R_GLDEPARTMENT: '',
        R_GLFUND: '',
        R_CAJOB: '',
        PRICEBASIS: null,
        R_FEES: '',
        ITEMSUPCCODE: '',
        RFRECEIPTVALIDATION: 'N',
        RFSHIPMENTVALIDATION: 'N',
        INTRANSACTIONNUMBER: '',
        DATELASTRECEIPT: null,
        R_PARTICIPANT: '',
        COMMISSIONBASIS: '',
        COMMISSIONAMOUNT: null,
        ROUNDINGMETHOD: '',
        ROUNDINGFACTOR: null,
        ALTERNATESTANDARDCOST: null,
        ALTERNATEAVERAGECOST: null,
        ALTERNATELASTCOST: null,
        PREVSTORAGEBILLEDDATE_LAST: null,
        PREVSTORAGEBILLEDDATE_NEXT: null,
        RECURRINGSTORAGE: 'Y',
        PROGRESSIVECURRENTRATE: null,
        PROGRESSIVELASTRATE:  null,
        PROGRESSIVEPREVIOUSLASTRATE:  null,
        PROGRESSIVEBILLINGCOUNT:  null,
        R_LOT_SOURCE: '',
        OVERSELLPERCENTAGE:  null,
        RECORD: '',        
        INVENTORYUNITNOTUSED:1,
        GROSSMINUSNET:null,
        ITEMRATESOURCE: ''
    };

    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const formRefs = useRef({});

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            if (formFields.ROWID == "00000000-0000-0000-0000-000000000000") {
                await insertLot();
            }
            else {
                await updateLot();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const insertLot = async () => {
        try {
            const url = "wm/Lot/InsertLot";

            let fields = formFields;
            fields.DATEINTRODUCED = GetFormatedDateWithTime(formFields.DATEINTRODUCED);
            fields.DATEAVAILABLE = GetFormatedDateWithTime(formFields.DATEAVAILABLE);
            fields.DATEEXPIRATION = GetFormatedDateWithTime(formFields.DATEEXPIRATION);
            fields.STORAGEBILLINGSTARTDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGSTARTDATE);
            fields.STORAGEBILLINGENDDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGENDDATE);
            fields.USERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1);
            fields.USERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2);
            fields.USERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3);
            fields.USERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4);
            fields.USERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5);
            fields.USERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6);
            fields.USERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7);
            fields.USERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8);
            fields.USERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9);
            fields.USERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10);
            fields.STORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_LAST);
            fields.STORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_NEXT);
            fields.DATELASTRECEIPT = GetFormatedDateWithTime(formFields.DATELASTRECEIPT);
            fields.PREVSTORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_LAST);
            fields.PREVSTORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_NEXT);

            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                setformFields(prevFields => ({
                    ...prevFields,
                    ROWID: response.data.ROWID,
                    RECORD: response.data.RECORD
                }));
                notify(
                    {
                        message: "Lot Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } 
        } catch (error) {
            console.error('Error submitting form:', error);
            if(error.response.data.ERRORS && error.response.data.ERRORS.length > 0)
            {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
            else
            {
                notify(
                    {
                        message: "Could not create lot. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }
            
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateLot = async () => {
        try {
            const url = "wm/Lot/UpdateLot";
            let fields = formFields;
            fields.LASTUPDATEDATETIME = null;
            fields.DATEINTRODUCED = GetFormatedDateWithTime(formFields.DATEINTRODUCED);
            fields.DATEAVAILABLE = GetFormatedDateWithTime(formFields.DATEAVAILABLE);
            fields.DATEEXPIRATION = GetFormatedDateWithTime(formFields.DATEEXPIRATION);
            fields.STORAGEBILLINGSTARTDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGSTARTDATE);
            fields.STORAGEBILLINGENDDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGENDDATE);
            fields.USERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1);
            fields.USERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2);
            fields.USERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3);
            fields.USERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4);
            fields.USERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5);
            fields.USERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6);
            fields.USERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7);
            fields.USERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8);
            fields.USERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9);
            fields.USERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10);
            fields.STORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_LAST);
            fields.STORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_NEXT);
            fields.DATELASTRECEIPT = GetFormatedDateWithTime(formFields.DATELASTRECEIPT);
            fields.PREVSTORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_LAST);
            fields.PREVSTORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_NEXT);

            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data  || !response.data.ERRORS.length > 0)  {
                notify(
                    {
                        message: "Lot Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } 
            

        } catch (error) {
            console.error('Error submitting form:', error);
            
            if(error.response.data.ERRORS && error.response.data.ERRORS.length > 0)
            {
                var errorsArray = [];

                for (let i = 0; i < error.response.data.ERRORS.length; i++) {
                    
                    errorsArray.push(error.response.data.ERRORS[i]);
                }
                
                if(errorsArray.length > 0)
                {
                    const errorHtml = errorsArray.map(err => `<div>${err}</div>`).join('');
                    custom({
                        title: "Errors",
                        messageHtml: errorHtml,
                        buttons: [{ text: "OK", onClick: () => { } }]
                    }).show();
                }
            }
            else
            {
                notify(
                    {
                        message: "Could not create lot. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const primaryFormLookupsLoad =() => {
        primaryFormLoad();
        handleUOMFormLoad();
        statusFormLookupsLoad();
    }

    const primaryFormLoad =()=>{
        
        loadLookupFromStaticData(formRefs,"STATUS",[{id:'A',name:"Active"},{id:'I',name:"Inactive"},{id:'D',name:"Delete"}]);
    }

    
    const loadLookupFromStaticData = (formRefs,name,dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if(formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };

    const handleReset = () => {

        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else 
        {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableControlsForNewRecord();
        }

    };

    const DeleteClick = async () => {
        let result = confirm("<i>Are your sure you want to delete this record?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                try 
                {
                    const response = await axios.post(`${window._env_.REACT_APP_APIS}/${'wm/lot/DeleteLot'}`, formFields.ROWID, {
                        headers: {
                            'Content-Type': 'application/json',
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        },
                    });
                    
                    if (!response.data.ERRORS.length > 0) {
                        notify(
                            {
                                message: "Lot Deleted",
                                width: 100,
                            },
                            'success',
                            3000,
                        );
                        setLoadPanelVisible(false);
                        history.push('/wm/codes/lot-data-entry');
                    } 
                    else 
                    {
                        setLoadPanelVisible(false);
                        const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: "Errors",
                            messageHtml: errorHtml,
                            buttons: [{ text: "OK", onClick: () => { } }]
                        }).show();
                    }
                } 
                catch (error) 
                {
                    
                    setLoadPanelVisible(false);

                    if(error.response.data.ERRORS && error.response.data.ERRORS.length > 0)
                    {
                        var hasConfirmation = false;
                        var errorMessage = "";
                        var errorsArray = [];

                        for (let i = 0; i < error.response.data.ERRORS.length; i++) {
                            
                            if (error.response.data.ERRORS[i].startsWith("[MakeLotInactiveConfirmation]"))
                            {
                                hasConfirmation = true;
                                errorMessage = error.response.data.ERRORS[i];
                                errorMessage = errorMessage.replace('[MakeLotInactiveConfirmation]','');
                                errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                            }
                            else
                            {
                                errorsArray.push(error.response.data.ERRORS[i]);
                            }
                        }
                        
                        if(errorsArray.length > 0)
                        {
                            const errorHtml = errorsArray.map(err => `<div>${err}</div>`).join('');
                            custom({
                                title: "Errors",
                                messageHtml: errorHtml,
                                buttons: [{ text: "OK", onClick: () => { } }]
                            }).show();
                        }
                        else
                        {
                            if (hasConfirmation)
                            {
                                let confirmResult = await confirm(errorMessage, "Confirm");
                                confirmResult.then(async (dialogResult) => {
                                    if (dialogResult) 
                                    {   
                                        if (formRefs.current["STATUS"]) {
                                            formRefs.current["STATUS"].instance().option('value', "I");
                                        }

                                        notify(
                                            {
                                                message: "Changed Lot status to \"Inactive\". Please click on save button to save this lot.",
                                                width: 100,
                                            },
                                            'success',
                                            3000,
                                        );
                                    }
                                });
                            }
                        }
                    }
                    else
                    {
                        notify(
                            {
                                message: "Could not delete lot. An error occurred",
                                width: 100,
                            },
                            'error',
                            3000,
                        );
                    }
                } 
            }
        })
    }

    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        history.push('/wm/codes/add-lot');
        EnableControlsForNewRecord();
    }

    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            axios.get(`${window._env_.REACT_APP_APIS}/wm/lot/GetLotDataByRowId?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data.Item1;

                if (responseData && responseData.ROWID) {
                    skipDataLoading = true;
                    responseData.INVENTORYUNITNOTUSED = 1;
                    if(responseData.NETWEIGHTQUANTITY != null && responseData.GROSSWEIGHTQUANTITY != null)
                    {
                        responseData.GROSSMINUSNET =  responseData.GROSSWEIGHTQUANTITY - responseData.NETWEIGHTQUANTITY;
                    }
                    setformFields(responseData);
                    skipDataLoading = false;
                    if(responseData.REORDERMETHODFLAG == "N"){
                        reOrderMethodFlag = true;
                    } 
                    if (formRefs.current["R_ITEM"]) {
                        formRefs.current["R_ITEM"].instance().option('disabled', true);
                    }
                    if (formRefs.current['R_RATESCHEDULE'])
                    {
                        if (responseData.ITEMRATESOURCE == 'L')
                        {
                            formRefs.current['R_RATESCHEDULE'].instance().option('disabled', false);
                        }
                        else
                        {
                            formRefs.current['R_RATESCHEDULE'].instance().option('disabled', true);
                        }
                    }
                }
                else {
                    console.error('Failed to get lot data');
                }
            });


        } catch (error) {
            console.error('Error failed to get lot data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
    }, []);

    const goBack = () => {
        history.push("/wm/codes/lot-data-entry");
    };

    const EnableControlsForNewRecord = () => {
        
        if (formRefs.current["R_ITEM"]) {
            formRefs.current["R_ITEM"].instance().option('disabled', false);
        }

        if (formRefs.current["R_RATESCHEDULE"]) {
            formRefs.current["R_RATESCHEDULE"].instance().option('disabled', false);
        }

    }

    const GetLotDataFromProfile = async (itemRowId) => {
        if (itemRowId === null)
            return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/wm/Lot/GetLotDataByProfileItemRowId?rowid=${itemRowId}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.hasOwnProperty("data") && response.data != null && response.data != undefined && response.data != "") {
                var responseData = response.data.Item1;
                var item = response.data.Item2;

                if (responseData) 
                {
                    responseData.ROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.R_ITEM = itemRowId;
                    responseData.RECORD = '';
                    responseData.CREATIONDATETIME = null;
                    responseData.LASTUPDATEDATETIME = null;
                    responseData.CREATIONUSERID =  '';
                    responseData.LASTUPDATEUSERID =  '';
                    responseData.COMPANYID =  '';
                    responseData.MODULE =  'WM';
                    responseData.RECORDTYPE =  'R';
                    responseData.ON_HAND = 0;
                    responseData.IN_ORDERED = 0;
                    responseData.OUT_ORDERED = 0;
                    responseData.IN_RECEIVING = 0;
                    responseData.OUT_SHIPPED = 0;
                    responseData.IN_BACKORDER = 0;
                    responseData.OUT_BACKORDER = 0;
                    responseData.IN_UNAVAILABLE = 0;
                    responseData.OUT_UNAVAILABLE = 0;
                    responseData.IN_FUTURE = 0;
                    responseData.OUT_FUTURE = 0;
                    responseData.AVAILABLE = 0;
                    responseData.NETAVAILABLE = 0;

                    responseData.DATEINTRODUCED =  new Date();
                    responseData.DATEAVAILABLE = new Date();
                    if(item.STORAGEBILLINGSTARTDATE != null && item.STORAGEBILLINGSTARTDATE != '')
                    {
                        responseData.STORAGEBILLINGSTARTDATE = item.STORAGEBILLINGSTARTDATE;
                    }
                    else
                    {
                        responseData.STORAGEBILLINGSTARTDATE = new Date();
                    }
                    responseData.STORAGEBILLINGENDDATE = new Date(2999, 11, 31);
                    responseData.COSTALLOCATIONFACTOR = 100.0000;
                    responseData.INVENTORYUNITNOTUSED = 1;
                    responseData.DESCRIPTION_1 = item.DESCRIPTION_1;
                    responseData.DESCRIPTION_2 = item.DESCRIPTION_2;
                    responseData.CUSTOMERCODE = item.IDENTITYID;
                    responseData.PROFILECODE = item.PROFILECODE;

                    if ((responseData.COSTBASISMETHODFLAG == null || responseData.COSTBASISMETHODFLAG == '') && (formFields.COSTBASISMETHODFLAG == null || formFields.COSTBASISMETHODFLAG == '')) 
                    {
                        responseData.COSTBASISMETHODFLAG  = item.COSTBASISMETHODFLAG;
                    }

                    if ((responseData.PRICESOURCE == null || responseData.PRICESOURCE == '') && (formFields.PRICESOURCE == null || formFields.PRICESOURCE == '')) 
                    {
                        responseData.COSTBASISMETHODFLAG  = item.PRICESOURCE;
                    }

                    if ((responseData.REORDERMETHODFLAG == null || responseData.REORDERMETHODFLAG == '') && (formFields.REORDERMETHODFLAG == null || formFields.REORDERMETHODFLAG == '')) 
                    {
                        responseData.REORDERMETHODFLAG  = item.REORDERMETHODFLAG;
                    }

                    if(formFields.ROUNDINGMETHOD == null || formFields.ROUNDINGMETHOD == '')
                    {
                        responseData.ROUNDINGMETHOD = item.ROUNDINGMETHOD;
                    }

                    if(formFields.ROUNDINGFACTOR == null)
                    {
                        responseData.ROUNDINGFACTOR = item.ROUNDINGFACTOR;
                    }

                    if (formRefs.current['R_RATESCHEDULE'])
                    {
                        if (item.RATESOURCE == 'L')
                        {
                            formRefs.current['R_RATESCHEDULE'].instance().option('disabled', false);
                        }
                        else
                        {
                            formRefs.current['R_RATESCHEDULE'].instance().option('disabled', true);
                        }
                    }

                    if(formFields.R_RATESCHEDULE == null || formFields.R_RATESCHEDULE == '')
                    {
                        responseData.R_RATESCHEDULE = item.R_RATESCHEDULE;
                    }

                    if(formFields.CLASSCODE == null || formFields.CLASSCODE == '')
                    {
                        responseData.CLASSCODE = item.CLASSCODE;
                    }

                    if(formFields.SUBCLASSCODE == null || formFields.SUBCLASSCODE == '')
                    {
                        responseData.CLASSCODE = item.CLASSCODE;
                    }

                    if(formFields.R_LOCATION == null || formFields.R_LOCATION == '')
                    {
                        responseData.R_LOCATION = item.R_LOCATION;
                    }

                    if(formFields.PHYSICALCOUNTCODE == null || formFields.PHYSICALCOUNTCODE == '')
                    {
                        responseData.PHYSICALCOUNTCODE = item.PHYSICALCOUNTCODE;
                    }

                    if(formFields.R_OEMMANUFACTUREID == null || formFields.R_OEMMANUFACTUREID == '')
                    {
                        responseData.R_OEMMANUFACTUREID = item.R_OEMMANUFACTUREID;
                    }

                    if(formFields.OEMMANUFACTURERCODE == null || formFields.OEMMANUFACTURERCODE == '')
                    {
                        responseData.OEMMANUFACTURERCODE = item.OEMMANUFACTURERCODE;
                    }

                    if (formFields.R_PRICETABLE == null || formFields.R_PRICETABLE == '')
                    {
                        responseData.R_PRICETABLE = item.R_PRICETABLE;
                    }

                    if (formFields.STANDARDCOST == 0)
                    {
                        responseData.STANDARDCOST = item.STANDARDCOST;
                    }

                    if (formFields.INVENTORYUNITUOM == null || formFields.INVENTORYUNITUOM == '')
                    {
                        responseData.INVENTORYUNITUOM = item.INVENTORYUNITUOM;
                    }

                    if (formFields.PIECESPERUNITQUANTITY == null ||formFields.PIECESPERUNITQUANTITY == '')
                    {
                        responseData.PIECESPERUNITQUANTITY = item.PIECESPERUNITQUANTITY;
                    }

                    if (formFields.PIECESPERUNITUOM == null ||formFields.PIECESPERUNITUOM == '')
                    {   
                        responseData.PIECESPERUNITUOM = item.PIECESPERUNITUOM;
                    }

                    if (formFields.UNITSPERPACKAGEQUANTITY == null ||formFields.UNITSPERPACKAGEQUANTITY == 0)
                    {
                        responseData.UNITSPERPACKAGEQUANTITY = item.UNITSPERPACKAGEQUANTITY;
                    }

                    if (formFields.UNITSPERPACKAGEUOM == null ||formFields.UNITSPERPACKAGEUOM == '')
                    {
                        responseData.UNITSPERPACKAGEUOM = item.UNITSPERPACKAGEUOM;
                    }

                    if (formFields.PACKAGESPERSHIPPINGUNITQTY == null ||formFields.PACKAGESPERSHIPPINGUNITQTY == 0)
                    {
                        responseData.PACKAGESPERSHIPPINGUNITQTY = item.PACKAGESPERSHIPPINGUNITQTY;
                    }

                    /*
                    if (formFields.PACKAGESPERSHIPPINGUNITUOM == null ||formFields.UNITSPERPACKAGEUOM.AsString = '') then
                    formFields.PACKAGESPERSHIPPINGUNITUOM.Assign(qryIMItemPACKAGESPERSHIPPINGUNITUOM);
                    if (formFields.UNITVOLUMEQUANTITY == null ||formFields.UNITVOLUMEQUANTITY.AsFloat = 0) then
                    formFields.UNITVOLUMEQUANTITY.Assign(qryIMItemUNITVOLUMEQUANTITY);
                    if (formFields.UNITVOLUMEUOM == null ||formFields.UNITVOLUMEUOM.AsString = '') then
                    formFields.UNITVOLUMEUOM.Assign(qryIMItemUNITVOLUMEUOM);
                    if (formFields.UNITAREAQUANTITY == null ||formFields.UNITAREAQUANTITY.AsFloat = 0) then
                    formFields.UNITAREAQUANTITY.Assign(qryIMItemUNITAREAQUANTITY);
                    if (formFields.UNITAREAUOM == null ||formFields.UNITAREAUOM.AsString = '') then
                    formFields.UNITAREAUOM.Assign(qryIMItemUNITAREAUOM);
                    if (formFields.UNITVALUEQUANTITY == null ||formFields.UNITVALUEQUANTITY.AsFloat = 0) then
                    formFields.UNITVALUEQUANTITY.Assign(qryIMItemUNITVALUEQUANTITY);
                    if (formFields.UNITVALUEUOM == null ||formFields.UNITVALUEUOM.AsString = '') then
                    formFields.UNITVALUEUOM.Assign(qryIMItemUNITVALUEUOM);
                    if (formFields.NETWEIGHTQUANTITY == null ||formFields.NETWEIGHTQUANTITY.AsFloat = 0) then
                    formFields.NETWEIGHTQUANTITY.Assign(qryIMItemNETWEIGHTQUANTITY);
                    if (formFields.NETWEIGHTUOM == null ||formFields.NETWEIGHTUOM.AsString = '') then
                    formFields.NETWEIGHTUOM.Assign(qryIMItemNETWEIGHTUOM);
                    if (formFields.GROSSWEIGHTQUANTITY == null ||formFields.GROSSWEIGHTQUANTITY.AsFloat = 0) then
                    formFields.GROSSWEIGHTQUANTITY.Assign(qryIMItemGROSSWEIGHTQUANTITY);
                    if (formFields.GROSSWEIGHTUOM == null ||formFields.GROSSWEIGHTUOM.AsString = '') then
                    formFields.GROSSWEIGHTUOM.Assign(qryIMItemGROSSWEIGHTUOM);
                    if (formFields.LOTTAREWEIGHT == null ||formFields.LOTTAREWEIGHT.AsFloat = 0) then
                    formFields.LOTTAREWEIGHT.Assign(qryIMItemITEMTAREWEIGHT);
                    if (formFields.P_GLDEPARTMENT == null ||formFields.P_GLDEPARTMENT.AsString = '') then
                    formFields.P_GLDEPARTMENT.Assign(qryIMItemP_GLDEPARTMENT);
                    if (formFields.P_GLFUND == null ||formFields.P_GLFUND.AsString = '') then
                    formFields.P_GLFUND.Assign(qryIMItemP_GLFUND);
                    if (formFields.P_CAJOB == null ||formFields.P_CAJOB.AsString = '') then
                    formFields.P_CAJOB.Assign(qryIMItemP_CAJOBCODE);

                    if qryIMLotRFRECEIPTVALIDATION.IsNull then
                    qryIMLotRFRECEIPTVALIDATION.AsString := 'N';
                    if qryIMLotRFSHIPMENTVALIDATION.IsNull then
                    qryIMLotRFSHIPMENTVALIDATION.AsString := 'N';
                    if qryIMLotCOMMISSIONBASIS.IsNull then
                    qryIMLotCOMMISSIONBASIS.AsString := 'U';
                    if qryIMLotRECURRINGSTORAGE.IsNull then
                    qryIMLotRECURRINGSTORAGE.AsString := 'Y';

                    // Default PriceSource to Item Master
                    qryIMLotPriceSource.AsString := 'I';
                    qryIMLOTP_PRICETABLE.Clear;

                    if qryIMLotCOSTBASISMETHODFLAG.IsNull then
                    qryIMLotCOSTBASISMETHODFLAG.AsString := 'I';
                    */

                    setformFields(responseData);
                    
                }
            }
            else {
                console.error('Failed to get item profile data');
            }
        } catch (error) {
            console.error('Error fetching item profile data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    const handleFieldChange = useCallback((name, value, e) => {
        if (name == "R_ITEM" && !skipDataLoading) {
            GetLotDataFromProfile(value);
        }

        if (name == "NETWEIGHTQUANTITY"  && !skipDataLoading) 
        {
            var tareWeightQty = null;
            if (formRefs.current['GROSSMINUSNET'])
            {
                tareWeightQty = formRefs.current['GROSSMINUSNET'].instance().option('value');
            }

            let calculatedValue= (tareWeightQty == null ? 0 : tareWeightQty) + value;
            if (formRefs.current['GROSSWEIGHTQUANTITY'])
                formRefs.current['GROSSWEIGHTQUANTITY'].instance().option('value',calculatedValue);
        }

        if (name == "GROSSMINUSNET"  && !skipDataLoading) 
        {
            var netWeightQty = null;
            if (formRefs.current['NETWEIGHTQUANTITY'])
            {
                netWeightQty = formRefs.current['NETWEIGHTQUANTITY'].instance().option('value');
            }


            let calculatedValue = (netWeightQty == null ? 0 : netWeightQty) + value;
            if (formRefs.current['GROSSWEIGHTQUANTITY'])
                formRefs.current['GROSSWEIGHTQUANTITY'].instance().option('value',calculatedValue);
        }
        
    });

   const handleUOMFormLoad = useCallback(() => {
        loadLookupFromStaticData(formRefs,"RFRECEIPTVALIDATION",[{id:'Y',name:"EDI import to insert Serial # records for valdation by RF program"},{id:'N',name:"EDI import to gonre Serial # records or Serial #s do not exist"}]);
        loadLookupFromStaticData(formRefs,"RFSHIPMENTVALIDATION",[{id:'Y',name:"EDI import to insert Serial # records for valdation by RF program"},{id:'N',name:"EDI import to gonre Serial # records or Serial #s do not exist"}]);
        loadLookupFromStaticData(formRefs,"RECURRINGSTORAGE",[{id:'Y',name:"Yes, Always Generate Recurring Storage Charges"},{id:'N',name:"No, Never Generate Recurring Storage Charges"}]);
        
        if(formRefs.current['INVENTORYUNITNOTUSED'])
        {
            formRefs.current['INVENTORYUNITNOTUSED'].instance().option('value',1);
        }
    });

    // Status Tab start
    const statusFormLookupsLoad =() => {
        statusFormLoad();
    }

    const statusFormLoad=()=>{
        loadLookupFromStaticData(formRefs,"REORDERMETHODFLAG",[{id:'F',name:"By Fixed Date"},{id:'N',name:"Not Applicable"},{id:'M',name:"Based on Minimum Quantity"},{id:'D',name:"Based on Minimum Days"}]);
        if (formFields.ROWID == "00000000-0000-0000-0000-000000000000" || reOrderMethodFlag == true) {
             if (formRefs.current['REORDERINVENTORYMINIMUMQTY'])
                formRefs.current['REORDERINVENTORYMINIMUMQTY'].instance().option('disabled', true);
            if (formRefs.current['REORDERINVENTORYMAXIMUMQTY'])
                formRefs.current['REORDERINVENTORYMAXIMUMQTY'].instance().option('disabled', true);
            if (formRefs.current['REORDERMINIMUMDAYSONHAND'])
                formRefs.current['REORDERMINIMUMDAYSONHAND'].instance().option('disabled', true);
            if (formRefs.current['REORDERMAXIMUMDAYSONHAND'])
                formRefs.current['REORDERMAXIMUMDAYSONHAND'].instance().option('disabled', true);
            if (formRefs.current['REORDERQUANTITYENTERED'])
                formRefs.current['REORDERQUANTITYENTERED'].instance().option('disabled', true);
            if (formRefs.current['REORDERQUANTITYEOQCALCULATED'])
                formRefs.current['REORDERQUANTITYEOQCALCULATED'].instance().option('disabled', true);
            if (formRefs.current['REORDERQUANTITYORDERMULTIPLE'])
                formRefs.current['REORDERQUANTITYORDERMULTIPLE'].instance().option('disabled', true);
            if (formRefs.current['REORDERSAFETYQUANTITY'])
                formRefs.current['REORDERSAFETYQUANTITY'].instance().option('disabled', true);
            if (formRefs.current['REORDERLEADTIME'])
                formRefs.current['REORDERLEADTIME'].instance().option('disabled', true);
            
        }
    }
    const handleStatusFieldChange=(name, value)=>{
        if (name == "REORDERMETHODFLAG" && value == "N" && value != undefined) {
            formRefs.current['REORDERINVENTORYMINIMUMQTY'].instance().option('disabled', true);
            formRefs.current['REORDERINVENTORYMAXIMUMQTY'].instance().option('disabled', true);
            formRefs.current['REORDERMINIMUMDAYSONHAND'].instance().option('disabled', true);
            formRefs.current['REORDERMAXIMUMDAYSONHAND'].instance().option('disabled', true);
            formRefs.current['REORDERQUANTITYENTERED'].instance().option('disabled', true);
            formRefs.current['REORDERQUANTITYEOQCALCULATED'].instance().option('disabled', true);
            formRefs.current['REORDERQUANTITYORDERMULTIPLE'].instance().option('disabled', true);
            formRefs.current['REORDERSAFETYQUANTITY'].instance().option('disabled', true);
            formRefs.current['REORDERLEADTIME'].instance().option('disabled', true);
            
            formRefs.current['REORDERINVENTORYMINIMUMQTY'].instance().option('value', null);
            formRefs.current['REORDERINVENTORYMAXIMUMQTY'].instance().option('value', null);
            formRefs.current['REORDERMINIMUMDAYSONHAND'].instance().option('value', null);
            formRefs.current['REORDERMAXIMUMDAYSONHAND'].instance().option('value', null);
            formRefs.current['REORDERQUANTITYENTERED'].instance().option('value', null);
            formRefs.current['REORDERQUANTITYEOQCALCULATED'].instance().option('value', null);
            formRefs.current['REORDERQUANTITYORDERMULTIPLE'].instance().option('value', null);
            formRefs.current['REORDERSAFETYQUANTITY'].instance().option('value', null);
            formRefs.current['REORDERLEADTIME'].instance().option('value', null);

        }else if (name == "REORDERMETHODFLAG" && value != "N" && value != undefined){
            formRefs.current['REORDERINVENTORYMINIMUMQTY'].instance().option('disabled', false);
            formRefs.current['REORDERINVENTORYMAXIMUMQTY'].instance().option('disabled', false);
            formRefs.current['REORDERMINIMUMDAYSONHAND'].instance().option('disabled', false);
            formRefs.current['REORDERMAXIMUMDAYSONHAND'].instance().option('disabled', false);
            formRefs.current['REORDERQUANTITYENTERED'].instance().option('disabled', false);
            formRefs.current['REORDERQUANTITYEOQCALCULATED'].instance().option('disabled', false);
            formRefs.current['REORDERQUANTITYORDERMULTIPLE'].instance().option('disabled', false);
            formRefs.current['REORDERSAFETYQUANTITY'].instance().option('disabled', false);
            formRefs.current['REORDERLEADTIME'].instance().option('disabled', false);
        }  
    }
 
    // Status Tab End

    const handleSelectionChange = useCallback((name, e) => {
            }, []);
    
    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Lot Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} disabled={props.isOpenAsPopUp} text="Back" />
                                </Item>
                            </Toolbar>
                            <TabPanel deferRendering={props.id?true:false} showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <PrimaryTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} primaryFormLookupsLoad={primaryFormLookupsLoad} formRefs={formRefs}/>
                                </TabItem>
                                <TabItem title="UOM" >
                                    <UOMTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handleUOMFormLoad={handleUOMFormLoad} formRefs={formRefs} />
                                </TabItem>
                               <TabItem title="Status">
                                    <StatusTab formFields={formFields} setformFields={setformFields} handleStatusFieldChange={handleStatusFieldChange} statusFormLookupsLoad={statusFormLookupsLoad}  formRefs={formRefs}/>
                                </TabItem>
                                <TabItem title="User Defined">
                                    <UserDefinedTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Sublots">
                                    <SublotsTab rowId={formFields.ROWID} />
                                </TabItem>
                                <TabItem title="Locations">
                                    <LocationsTab itemRowId={formFields.ROWID} type='lot'  />
                                </TabItem>
                                <TabItem title="Serial #" >
                                    <SerialNumberTab sourceId={formFields.ROWID}  formRefs={formRefs} type='lot' />
                                </TabItem>
                                <TabItem title="Charges">
                                    <ChargesTab sourceId={formFields.ROWID}  formRefs={formRefs}  type='lot' />
                                </TabItem>
                                <TabItem title="Unavailable">
                                    <UnavailableTab itemRowId={formFields.ROWID}  type='lot' />
                                </TabItem>
                            </TabPanel>
                            <div className="row">
                                <ValidationSummary className="pl-3 pt-1" id="summary" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);
